/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * FeatureStageOverrideProvider — DEBUG-ONLY implementation of the model's
 * `IFeatureStageOverrideProvider`, injected into `FeatureActivation` at
 * bootstrap in dev-tools builds only. Delegates to
 * `featureStageOverrideStorage`; it holds no state of its own, keeping
 * `FeatureActivation` unaware of any storage detail.
 */

import type { IFeatureStageOverrideProvider } from "../../model/interfaces";
import type { Feature, FeatureStage } from "../../model/featureActivation";
import { getFeatureStageOverride } from "./featureStageOverrideStorage";

export class FeatureStageOverrideProvider implements IFeatureStageOverrideProvider {
  public getStage(feature: Feature): FeatureStage | null {
    return getFeatureStageOverride(feature);
  }
}
